import {useQuery} from 'react-query';
import getViolationReason from '.';

const useGetViolationReason = ({type}: {type: string}) => {
  const {data, isLoading} = useQuery(['violaiation-reason'], () =>
    getViolationReason(type),
  );

  return {violationReasons: data, isLoading};
};

export default useGetViolationReason;
